import { render, staticRenderFns } from "./RefundList2_Fail.vue?vue&type=template&id=56193e15&scoped=true&"
import script from "./RefundList2_Fail.vue?vue&type=script&lang=js&"
export * from "./RefundList2_Fail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56193e15",
  null
  
)

export default component.exports